import {all, call, put, select, takeLatest} from 'redux-saga/effects';

import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';
import {getQueryString} from 'utils/queryString';
import {getJsonFromLocalStorage, storeLocally} from 'utils/localStorage';

import {
  CHANGE_PASSWORD,
  changePasswordFailed,
  changePasswordSuccess,
  CREATE_UPDATE_POST,
  createPostFailed,
  createPostSuccess,
  DELETE_POST,
  deletePostFailed,
  deletePostSuccess,
  FETCH_COMPANIES,
  FETCH_POSTS,
  fetchCompaniesSuccess,
  fetchPostsFailed,
  fetchPostsSuccess,
  UPDATE_LABEL,
  UPDATE_PROFILE,
  updateLabelFailed,
  updateLabelSuccess,
  updateProfileFailed,
} from 'actions/readerActions';

import {signinSuccess} from 'actions/userActions';
import {fetchCategoriesFailed} from 'actions/categoryActions';

function* fetchPosts(action) {
  const params = getQueryString(action.filters);

  const requestUrl = `reader?${params}`;
  const authToken = yield select(makeSelectUserToken());

  try {
    const response = yield call(request, requestUrl, authToken, {});
    yield put(fetchPostsSuccess(response.readerPost, response.labels));
  } catch (err) {
    yield put(fetchPostsFailed(err.message));
  }
}

function* fetchCompanies(action) {
  const params = getQueryString(action.filters);

  const requestUrl = `reader/company?${params}`;
  const authToken = yield select(makeSelectUserToken());

  try {
    const response = yield call(request, requestUrl, authToken, {});
    yield put(fetchCompaniesSuccess(response.readerPost, response.labels));
  } catch (err) {
    yield put(fetchCategoriesFailed(err.message));
  }
}

function* deletePost(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `reader/${action._id}`;
  const requestOptions = {
    method: 'DELETE',
  };

  try {
    yield call(request, requestUrl, authToken, requestOptions);
    yield put(deletePostSuccess(action._id));
  } catch (err) {
    yield put(deletePostFailed(err));
  }
}

function* createPost(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `reader`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);

    yield put(createPostSuccess(response.post));
  } catch (err) {
    yield put(createPostFailed(err));
  }
}

function* updateLabel(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `reader/labels`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);

    yield put(updateLabelSuccess(response.post));
  } catch (err) {
    yield put(updateLabelFailed(err));
  }
}

function* updateProfile(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `user/${action.details._id}`;
  console.log(action.details);
  const u = {
    email: action.details.email,
    firstName: action.details.firstName,
    lastName: action.details.lastName,
  };
  if (action.details.avatar) u.avatar = action.details.avatar;
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(u),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);
    const storedUser = getJsonFromLocalStorage('user');
    const {user} = response;
    const newUser = {
      ...storedUser,
      user: {
        ...storedUser.user,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        avatar: user.avatar,
      },
    };
    storeLocally('user', newUser);
    if (response.user.newEmail) {
      yield put(
        updateProfileFailed(
          `your new email ${response.user.newEmail} need validation.`
        )
      );
    } else {
      yield put(signinSuccess(newUser));
    }
  } catch (err) {
    let errorMessage = 'Something went wrong';
    if (err.message) {
      errorMessage = err.message;
    }
    yield put(updateProfileFailed(errorMessage));
  }
}

function* changePassword(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `user/${action.details._id}/updatePassword`;
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);
    yield put(changePasswordSuccess(response));
  } catch (err) {
    let errorMessage = 'Something went wrong';
    if (err.message) {
      errorMessage = err.message;
    }

    yield put(changePasswordFailed(errorMessage));
  }
}

export default function* readerSaga() {
  yield all([
    takeLatest(FETCH_POSTS, fetchPosts),
    takeLatest(CREATE_UPDATE_POST, createPost),
    takeLatest(DELETE_POST, deletePost),
    takeLatest(FETCH_COMPANIES, fetchCompanies),
    takeLatest(UPDATE_LABEL, updateLabel),
    takeLatest(UPDATE_PROFILE, updateProfile),
    takeLatest(CHANGE_PASSWORD, changePassword),
  ]);
}
